import StorageInterface from './storage.interface';

class LocalStorage implements StorageInterface {
    public getItem(key: string) {
        try {
            return localStorage.getItem(key);
        } catch (e) {
            return false;
        }
    }

    public setItem(key: string, value: string) {
        try {
            return localStorage.setItem(key, value);
        } catch (e) {
            return false;
        }
    }

    public removeItem(key: string) {
        try {
            return localStorage.removeItem(key);
        } catch (e) {
            return false;
        }
    }
}

export const Storage = new LocalStorage();
